export const enviroment = {
  baseApi: "https://hasadevelopment.azurewebsites.net/api/v1",
  // baseUrl: "https://navigate.one/hasa/",
  baseUrl: "https://staging.hasa.com.br/",
};
